import Axios from '@/api/http'

/**
 * 上传返回
 * */
export function apiImportapproval(date) {
  return Axios({
    method: 'post',
    url: '/api/importapproval',
    data: date,
    timeout: 60000 * 3
  })
}

/**
 * 根据数据id批量更新数据
 * */
export function updateapprovingbatch(date) {
  return Axios({
    method: 'post',
    url: '/api/updateapprovingbatch',
    data: date,
    timeout: 60000 * 3
  })
}


/**
 * 应用短信二次验证查询接口(查询是否需要进行验证)
 * */
export function openapiValidateapprovalsms(date) {
  return Axios({
    method: 'post',
    url: '/openapi/validateapprovalsms',
    data: date,
  })
}

/**
 * 应用及仪表盘短信二次验证发送短信接口(发送验证码)
 * */
export function mobileGetapprovalvalidcode(date) {
  return Axios({
    method: 'post',
    url: '/mobile/getapprovalvalidcode',
    data: date,
  })
}

/**
 * 获取应用及仪表盘短信二次验证结果接口(验证结果)
 * */
export function openapiGetappvalidate(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getappvalidate',
    data: date,
  })
}

/**
 * 仪表盘短信二次验证查询接口(查询是否需要进行验证)
 * */
export function apiValidateapprovaldashboardsms(date) {
  return Axios({
    method: 'post',
    url: '/api/validateapprovaldashboardsms',
    data: date,
  })
}

/**
 * 数据中心模板
 * */
export function getapifielddatalist(date) {
  return Axios({
    method: 'post',
    url: '/api/getfielddatalist',
    data: date,
  })
}

export function getopenreportformlist(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getreportformlist',
    data: date,
  })
}

export function getvalidateapproval(date) {
  return Axios({
    method: 'post',
    url: '/openapi/validateapproval',
    data: date,
  })
}

export function getmyreportapprovallist(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getmyreportapprovallist',
    data: date,
  })
}

/**
 * 验证使用
 * addvalidaterecord(默认值设置)
 * validateapprovaldashboarddata(仪表盘验证)
 * validatedata(表单提交验证)
 * removevalidaterecord(取消验证记录-默认值设置)
 */
export function addvalidaterecord(date) {
  return Axios({
    method: 'post',
    url: '/openapi/addvalidaterecord',
    data: date,
  })
}
export function validateapprovaldashboarddata(date) {
  return Axios({
    method: 'post',
    url: '/api/validateapprovaldashboarddata',
    data: date,
  })
}
export function validatedata(date) {
  return Axios({
    method: 'post',
    url: '/openapi/validatedata',
    data: date,
  })
}
export function removevalidaterecord(date) {
  return Axios({
    method: 'post',
    url: '/openapi/removevalidaterecord',
    data: date,
  })
}

/**
 * 归档
 * */
export function archivedata(date) {
  return Axios({
    method: 'post',
    url: '/openapi/archivedata',
    data: date
  })
}

/**
 * 批量删除
 * */
export function deletebycondition(date) {
  return Axios({
    method: 'post',
    url: '/api/deletebycondition',
    data: date
  })
}

/**
 * 获取批量修改字段获取
 * */
export function getapprovalfeild(date) {
  return Axios({
    method: 'post',
    url: '/api/getapprovalfeild',
    data: date
  })
}

/**
 * 获取批量修改
 * */
export function batchupdatedata(date) {
  return Axios({
    method: 'post',
    url: '/api/batchupdatedata',
    data: date
  })
}

/**
 * 是否开启了归档
 * */
export function isopenarchive(date) {
  return Axios({
    method: 'post',
    url: '/openapi/isopenarchive',
    data: date
  })
}

/**
 * 批量导出pdf
 * */
export function batchexportpdf(date) {
  return Axios({
    method: 'post',
    url: '/api/batchexportpdf',
    data: date
  })
}

/**
 * 获取pdf导出列表
 * */
export function getpdfZiplist(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getpdfZiplist',
    data: date
  })
}

/**
 * 删除pdf包
 * */
export function deletepdfzipbyid(date) {
  return Axios({
    method: 'post',
    url: '/openapi/deletepdfzipbyid',
    data: date
  })
}

/**
 * 删除pdf包
 * */
export function getapprovalcontent(date) {
  return Axios({
    method: 'post',
    url: '/api/getapprovalcontent',
    data: date
  })
}
/**
 * 删除pdf包
 * */
export function getbespeakorganizationList(date) {
  return Axios({
    method: 'post',
    url: '/api/getbespeakorganizationList',
    data: date
  })
}
/**
 * 恢复数据
 * */
export function recycledata(date) {
  return Axios({
    method: 'post',
    url: '/api/recycledata',
    data: date
  })
}
/**
 * 回收站数据删除
 * */
export function deleterecycledata(date) {
  return Axios({
    method: 'post',
    url: '/api/deleterecycledata',
    data: date
  })
}
/**
 * 获取回收站数据列表
 * */
export function getrecycledatalist(date) {
  return Axios({
    method: 'post',
    url: '/api/getrecycledatalist',
    data: date
  })
}
/**
 * 根据条件删除数据
 * */
export function deleterecycledatabycondition(date) {
  return Axios({
    method: 'post',
    url: '/api/deleterecycledatabycondition',
    data: date
  })
}
/**
 * 根据条件回复数据
 * */
export function recycledatabycondition(date) {
  return Axios({
    method: 'post',
    url: '/api/recycledatabycondition',
    data: date
  })
}
/**
 * 导出获取已导出的字段
 * */
export function getuserexportcontent(date) {
  return Axios({
    method: 'post',
    url: '/api/getuserexportcontent',
    data: date
  })
}
export const getapprovalreportpreview = (data) => {
  return Axios({
    method: 'post',
    url: '/api/getapprovalreportpreview',
    data: data
  })
}